import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  grid-gap: 24px 40px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const ResultsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  position: relative;
  font-weight: var(--font-regular);

  & > div {
    margin-top: 15px;
  }

  button {
    padding: 10px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    line-height: 1;
  }

  @media (max-width: 500px) {
    flex-wrap: wrap;
    row-gap: 20px;

    button {
      width: 100%;
    }
  }
`

export const NoResultsWrapper = styled.div`
  text-align: center;
  padding: 30px;
  width: 100%;
  border-radius: 15px;
  margin-top: 25px;
  border: 1px solid var(--brand-secondary);
  font-size: 17px;
`

export const HeadingContainer = styled.div`
  text-align: center;

  @media (max-width: 768px) {
    text-align: left;

    h1 {
      font-size: 32px;
    }
  }
`

export const SearchAndFilter = styled.div`
  display: flex;
  align-items: center;
`
export const SearchWrapper = styled.div`
  position: relative;
  width: 500px;

  @media (max-width: 600px) {
    width: 100%;
  }
`
export const SearchIcon = styled.svg`
  width: 20px;
  height: 20px;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  left: 15px;
`
export const SearchInput = styled.input`
  border: 1px solid lightgrey;
  border-radius: 30px;
  padding: 12px 50px;
  box-sizing: border-box;
  width: 100%;
  outline: none;

  &:focus {
    border: 1px solid black;
  }

  &::placeholder {
    color: darkgrey;
    opacity: 1;
    font-weight: var(--font-light);
  }
`
export const SearchButton = styled.button`
  border: none;
  border-radius: 64px;
  height: 30px;
  background: var(--brand-primary);
  color: var(--brand-secondary);
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 6px;
  font-size: var(--font-medium);
  cursor: pointer;
`
export const Filter = styled.div`
  margin-left: 16px;
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 8px;
  }

  & > button:not(:last-child) {
    margin-right: 4px;
  }
`

export const SearchQueries = styled.div`
  display: none;
  font-weight: var(--font-regular);
  margin-bottom: 32px;

  p:first-child {
    margin-bottom: 16px;
  }
  p:nth-child(n + 2) {
    margin-top: 6px;
  }
  strong {
    font-weight: var(--font-medium);
    margin-right: 6px;
  }

  @media (max-width: 768px) {
    display: block;
  }
`

export const ResultsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`
export const ResultsWrapperLeft = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
`
export const Sorting = styled.div`
  position: relative;
  top: -1px;

  &:before {
    content: '';
    position: absolute;
    top: calc(50% - 2px);
    right: 5px;
    width: 7px;
    height: 7px;
    border-right: 1px solid var(--brand-secondary);
    border-bottom: 1px solid var(--brand-secondary);
    display: block;
    transform: translateY(-50%) rotate(45deg);
  }

  & > select {
    padding: 5px 10px;
    border: 0;
    background: transparent;
    border-left: 1px solid var(--grey-25);
    font-weight: var(--font-regular);
    width: 160px;
    color: var(--brand-secondary);
    font-size: 13px;
    appearance: none;
  }
`

export const ListingContainer = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  transition: 0.3s ease-in-out;
  gap: 25px;
  position: relative;
  padding-left: 0;
  min-height: 700px;

  @media (max-width: 768px) {
    min-height: 100px;
  }

  ${({ active }) =>
    active &&
    `
    @media (min-width: 769px) {
      padding-left: 270px;
      
      .product-tile__image {
        height: 184px;
      }
      .product-tile__badges {
        top: 158px;
      }
      .product-tile__hot-deal {
        top: 158px;
      }
    }
    
    @media (min-width: 1201px) and (max-width: 1350px) {
      > .listing-grid {
        grid-template-columns: repeat(3,minmax(0,calc(100% / 3)));
      }
    }
    
    @media (min-width: 769px) and (max-width: 1200px) {
      padding-left: 220px;
    }
  `}
`
